<script setup lang="ts">
defineProps({
  sortNames: {
    type: Object as PropType<SortNames>,
    required: true,
  },
});

const sortBy = defineModel<string>("sortBy", { required: true });
const isSortOpen = ref(false);
const sortContainer = ref<HTMLElement | null>(null);

watch(sortContainer, (newVal) => {
  if (isSortOpen.value && newVal) {
    newVal.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
});
</script>
<template>
  <div class="flex flex-col items-center justify-between">
    <div
      class="w-full flex items-baseline justify-between border-b border-secondary-500 px-8 py-4 cursor-pointer text-neutral-200"
      @click="isSortOpen = !isSortOpen">
      <p class="text-lg">{{ $t("main.toolbar.sort.sortBy") }}</p>
      <div class="flex items-center gap-4">
        <p class="text-xs text-neutral-300">
          {{ $t(`main.${sortNames[sortBy]?.tid}`) }}
        </p>
        <NuxtIcon
          name="mdi:keyboard-arrow-down"
          class="w-7 h-7 transition-all duration-300 shrink-0"
          :class="{ 'transform rotate-180': isSortOpen }" />
      </div>
    </div>
    <transition
      enter-active-class="transition ease duration-100"
      enter-from-class="transform opacity-0 -translate-y-5"
      enter-to-class="transform opacity-100 translate-y-0"
      leave-active-class="transition ease duration-100"
      leave-from-class="transform opacity-100 translate-y-0"
      leave-to-class="transform opacity-0 -translate-y-5">
      <div
        v-if="isSortOpen"
        ref="sortContainer"
        class="w-full flex flex-col justify-center gap-4 border-b border-secondary-500 px-8 py-4 transition-all duration-300 overflow-hidden bg-neutral-500">
        <form>
          <div class="flex flex-col gap-4">
            <template v-for="(sortName, sortKey) in sortNames" :key="sortName">
              <div
                v-if="$route.name?.toString() !== sortName.hide"
                class="flex items-center gap-2">
                <input
                  :id="sortName.value"
                  v-model="sortBy"
                  type="radio"
                  :name="sortName.value"
                  :value="sortKey"
                  class="appearance-none w-4 h-4 rounded-full ring-2 ring-neutral-300 border-2 border-neutral-500 cursor-pointer checked:bg-primary-500 checked:ring-primary-500 focus:outline-hidden"
                  :data-test="`input-filter-sort-${sortName.value}`" />
                <label
                  :for="sortName.value"
                  class="text-neutral-300 cursor-pointer">
                  {{ $t(`main.${sortName.tid}`) }}
                </label>
              </div>
            </template>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>
